import { create } from 'zustand';
import { WishlistItem } from '../types';

interface WishlistState {
  items: WishlistItem[];
  setItems: (items: WishlistItem[]) => void;
  addItem: (item: WishlistItem) => void;
  removeItem: (productId: string) => void;
  isInWishlist: (productId: string) => boolean;
}

export const useWishlistStore = create<WishlistState>((set, get) => ({
  items: [],

  setItems: (items) => set({ items }),

  addItem: (item) =>
    set((state) => ({
      items: [...state.items.filter(i => i.productId !== item.productId), item],
    })),

  removeItem: (productId) =>
    set((state) => ({ items: state.items.filter(i => i.productId !== productId) })),

  isInWishlist: (productId) => get().items.some(i => i.productId === productId),
}));
